<template>
    <div class="survey-banner" role="region" aria-label="MyUSE survey invitation">
      <b-container class="py-2">
        <div class="survey-banner__inner">
          <p class="survey-banner__text mb-0">
            We invite you to participate in a brief survey about your experience with MyUSE. We really appreciate your feedback and the survey will take approximately 5 minutes to complete.
          </p>
  
          <!-- Optional CTA button. Replace href with your real survey link -->
          <a
            class="survey-banner__cta"
            href="https://ucc.qualtrics.com/jfe/form/SV_50WL7zdX3Vx5KzY"
            target="_blank"
            rel="noopener noreferrer"
          >
            Take the survey
          </a>
        </div>
      </b-container>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SurveyBanner'
  }
  </script>
  
  <style scoped>
  /* Light blue that fits Argon/Bootstrap vibes without clashing */
  .survey-banner {
    background: rgba(94, 114, 228, 0.12);
    border-bottom: 1px solid rgba(94, 114, 228, 0.18);
  }
  
  .survey-banner__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  
  .survey-banner__text {
    color: #172b4d; /* Argon dark */
    font-size: 0.95rem;
    line-height: 1.35;
  }
  
  .survey-banner__cta {
    white-space: nowrap;
    font-weight: 600;
    color: #172b4d;
    text-decoration: underline;
  }
  
  @media (max-width: 768px) {
    .survey-banner__inner {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .survey-banner__cta {
      margin-top: 6px;
    }
  }
  </style>
  